import { AllClearIcon } from "../../atoms/animatedIcons";

/** Molekül: hiçbir kategoride uyarı yokken kartların üstünde duran bant. */
export default function AlertsAllClearBanner() {
  return (
    <div className="mb-5 flex items-center gap-3 rounded-2xl border border-emerald-100 bg-gradient-to-r from-emerald-50 to-teal-50 p-4 motion-safe:animate-cardRise">
      <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white text-emerald-600 ring-1 ring-emerald-100">
        <AllClearIcon className="h-6 w-6" />
      </span>
      <div>
        <p className="text-sm font-SemiBold text-emerald-800">Her şey yolunda!</p>
        <p className="text-xs text-emerald-700/80">Şu an dikkat edilmesi gereken bir uyarı yok.</p>
      </div>
    </div>
  );
}
